import { render, staticRenderFns } from "./NewSuppliers.vue?vue&type=template&id=2f27d433&scoped=true&"
import script from "./NewSuppliers.vue?vue&type=script&lang=js&"
export * from "./NewSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27d433",
  null
  
)

export default component.exports